import type { Candidate, FindPro, HireCandidatesListParams, MergedGroupMember } from "@sidegigllc/api/client";
import type { JobCandidateCardData } from "domains/hire/components/JobCandidateCard";
import type { CandidatesSearch } from "domains/hire/containers/Candidates/routing";
import { dropTopProBadge } from "domains/hire/utils";

// Larger first page so the grid fills the viewport without firing extra infinite-scroll fetches on load.
const CANDIDATES_PAGE_SIZE = 50;

export const buildCandidatesListParams = (
  {
    tab,
    ordering,
    pro_fullname,
    group_id: _group_id,
    candidate_id: _candidate_id,
    applicant_id: _applicant_id,
    offerType: _offerType,
    ...filters
  }: CandidatesSearch,
  { appliedOnly = false }: { appliedOnly?: boolean } = {},
): HireCandidatesListParams => ({
  ordering,
  page_size: CANDIDATES_PAGE_SIZE,
  pro_fullname: pro_fullname || undefined,
  ...filters,
  ...(tab === "favorites" ? { favorite_pro: true } : {}),
  ...(appliedOnly ? { applied_only: true } : {}),
});

export const mapHireCandidateToCardData = (
  candidate: Candidate | FindPro | MergedGroupMember,
): JobCandidateCardData => {
  const { gigster_profile } = candidate;

  return {
    id: candidate.id,
    first_name: candidate.first_name,
    last_name: candidate.last_name,
    user: gigster_profile.user_id,
    image_id: gigster_profile.headshot_public_id,
    badges: dropTopProBadge(gigster_profile.badges),
    is_preferred_pro: false,
    star_rating: candidate.rating ?? undefined,
    shifts_done: candidate.gigs_worked ?? undefined,
    completion_rate:
      candidate.completion_percentage == null ? undefined : Math.round(candidate.completion_percentage * 100),
  };
};
